import { OnInit } from '@angular/core';
import { Globals } from '../objects/Globals';
var WelcomeComponent = /** @class */ (function () {
    function WelcomeComponent(globals) {
        this.globals = globals;
    }
    WelcomeComponent.prototype.ngOnInit = function () {
        this.session = this.globals.Session.Session;
    };
    return WelcomeComponent;
}());
export { WelcomeComponent };
